import moment from "moment/moment";

export const formatDate = ({ date, view_time = true }) => {
    if (!date) {
        return 'Fecha no disponible';
    }

    const momentDate = moment(date, [
        moment.ISO_8601,
        "YYYY.MM.DD HH:mm",
        "DD-MM-YYYY HH:mm:ss",
        "YYYY-MM-DD HH:mm:ss",
        "D/M/YYYY HH:mm:ss",
        "D/M/YYYY HH:mm"
    ], true);

    if (!momentDate.isValid()) {
        return 'Fecha no válida';
    }

    return view_time ? momentDate.format("DD-MM-YYYY HH:mm:ss") : momentDate.format("DD-MM-YYYY");
};
